import * as getFetch from './fetch/get.js'
import * as store from './data/store.js'
import * as entropy from './data/entropy.js'
import * as ui from './ui.js'
import * as auth from './authenticate.js'
import * as refreshDate from './ui/refresh-date.js'
import * as routerUtilities from './utilities/router.js'
import * as dateParametersUI from './ui/date-parameters.js'
import * as resultsUI from './ui/report-results.js'
import * as locationsUI from './ui/locations.js'
import '../components/parameters/mt-report-locations.js'

const api = routerUtilities.getApi()
const host = window.location.hostname

let reportName = ''
let reportForm

export function initialize() {

    locationsUI.displayReportLocations()

    reportForm = document.getElementById('js-form--report')
    reportForm.addEventListener('submit', handleReportSubmission.bind({ api, host}))

    reportName = reportForm.dataset.endpoint
	dateParametersUI.initializeReportDates(reportForm)
}

// TODO - move locations stuff out of here so it can be easily reused
// If there's only 1 location, we don't need to prompt them to select it,
// just send it

export async function handleReportSubmission(e) {
    e.preventDefault()
    console.info({ reportName })

    // Display loading icon
    ui.removeReport()
    ui.displayLoadingAnimation()
    const submitElement = document.getElementById('js-generate-report')
    submitElement.setAttribute('disabled', 'disabled')

    const authRenewed = store.renewAuthentication()
	if(!authRenewed){await auth.logout()}

    const selectedLocations = entropy.getSelectedReportLocations()

    // TODO - move owner and selected locations into hidden fields?
    const owner = store.getOwner()

    const data = new FormData(e.target)

    const value = Object.fromEntries(data.entries())

    const parameters = {
        ...value,
        selectedLocations,
        owner: owner.id,
    }

    const report = e.target.dataset.endpoint
    const endpoint = `${api}/${report}`

    const results = await fetchReport({
        parameters,
        includeAuthorization: true,
        endpoint,
    })

    submitElement.removeAttribute('disabled')
    ui.hideLoadingAnimation()

    // TODO - logout and remove token if invalid
    if (results.hasError) {
        ui.displayError({ results })
    } else if(results.errorCode === 'INVALID_TOKEN') {
        console.error('invalid token')
    } else {
		const currentDate = store.getDataRefreshDate()
		
		if(currentDate < results.lastDataRefreshDate){
			const cancelFunction = function() {
				resultsUI.handleReportResults({ report, results })
			    }

			const reloadFunction = function() {
				dateParametersUI.initializeReportDates(reportForm)
			    }

			refreshDate.displayReloadDateConfirmation(results.lastDataRefreshDate, cancelFunction, reloadFunction)
		} else{
	        resultsUI.handleReportResults({ report, results })
			refreshDate.resetRefreshDateInterval()
		}
    }
}

/**
 *
 * {"hasError":true,"errorCode":"INVALID_TOKEN","errorMessage":"The authentication token could not be verified","reportData":[],"head":0.0,"averageWeight":0.0,"totalNetSale":0.0,"salesCWT":0.0}
 *
 * @param {*} endpoint
 * @param {} parameters
 */
export async function fetchReport({ endpoint, parameters, includeAuthorization }) {
    try {
        const data = await getFetch.getAFetch({ endpoint, parameters, includeAuthorization })

        return data
    } catch(e) {
        console.error(e)
        return {
            hasError: true,
            errorCode: e,
            errorMessage: `${e}: could not connect to the server`
        }
    }
    
}
